import { CircularProgress } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import CheckIcon from '@mui/icons-material/Check'
import AddIcon from '@mui/icons-material/Add'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined'
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined'
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import PolicyIcon from '@mui/icons-material/Policy'
import UmbrellaIcon from '../components/shared/UmbrellaIcon'
import InvoiceIcon from '../components/shared/InvoiceIcon'

import {
  DefaultIconComponentsMap,
  CircleKIconComponentsMap,
  DefaultIconPropsMap,
  CircleKIconPropsMap,
  PartnersIcons,
  IconType,
} from '../types/interface/icon.interface'
import CircleKSVGIcon from '../components/shared/CircleKSVGIcon'
import { PartnerName } from '../types/interface/quote.interface'

const defaultProps = {
  size: 24,
}

const defaultIconComponents: DefaultIconComponentsMap = {
  [IconType.LOADING]: CircularProgress,
  [IconType.ERROR]: CloseRoundedIcon,
  [IconType.CHECK]: CheckIcon,
  [IconType.ARROW_DOWN]: KeyboardArrowDownIcon,
  [IconType.CHEVRON_LEFT]: ChevronLeftIcon,
  [IconType.CHEVRON_RIGHT]: ChevronRightIcon,
  [IconType.CALENDAR]: InsertInvitationIcon,
  [IconType.CREATE]: CreateOutlinedIcon,
  [IconType.DOT]: FiberManualRecordIcon,
  [IconType.BEACH_ACCESS]: BeachAccessOutlinedIcon,
  [IconType.FILE_COPY]: FileCopyOutlinedIcon,
  [IconType.ADD]: AddIcon,
  [IconType.REMOVE]: DeleteOutlineIcon,
  [IconType.POLICY]: PolicyIcon,
  [IconType.UMBRELLA]: UmbrellaIcon,
  [IconType.INVOICE]: InvoiceIcon,
}

const defaultIconProps: DefaultIconPropsMap = {
  [IconType.LOADING]: {
    thickness: 2.5,
    size: 24,
  },
  [IconType.ERROR]: defaultProps,
  [IconType.CHECK]: defaultProps,
  [IconType.ARROW_DOWN]: defaultProps,
  [IconType.CHEVRON_LEFT]: defaultProps,
  [IconType.CHEVRON_RIGHT]: defaultProps,
  [IconType.CALENDAR]: defaultProps,
  [IconType.CREATE]: defaultProps,
  [IconType.DOT]: defaultProps,
  [IconType.BEACH_ACCESS]: defaultProps,
  [IconType.FILE_COPY]: defaultProps,
  [IconType.UMBRELLA]: defaultProps,
  [IconType.INVOICE]: defaultProps,
}

const circleKIconComponents: CircleKIconComponentsMap = {
  [IconType.LOADING]: CircleKSVGIcon,
  [IconType.ERROR]: CircleKSVGIcon,
  [IconType.CHECK]: CircleKSVGIcon,
  [IconType.ARROW_DOWN]: CircleKSVGIcon,
  [IconType.CHEVRON_LEFT]: ChevronLeftIcon,
  [IconType.CHEVRON_RIGHT]: ChevronRightIcon,
  [IconType.CALENDAR]: CircleKSVGIcon,
  [IconType.CREATE]: CreateOutlinedIcon,
  [IconType.DOT]: CircleKSVGIcon,
  [IconType.BEACH_ACCESS]: BeachAccessOutlinedIcon,
  [IconType.FILE_COPY]: FileCopyOutlinedIcon,
  [IconType.UMBRELLA]: UmbrellaIcon,
  [IconType.INVOICE]: InvoiceIcon,
}

const circleKIconProps: CircleKIconPropsMap = {
  [IconType.LOADING]: {
    type: IconType.LOADING,
  },
  [IconType.ERROR]: {
    type: IconType.ERROR,
    color: '#DA291C',
  },
  [IconType.CHECK]: {
    type: IconType.CHECK,
  },
  [IconType.ARROW_DOWN]: {
    type: IconType.ARROW_DOWN,
  },
  [IconType.CHEVRON_LEFT]: {
    type: IconType.CHEVRON_LEFT,
  },
  [IconType.CHEVRON_RIGHT]: {
    type: IconType.CHEVRON_RIGHT,
  },
  [IconType.CALENDAR]: {
    type: IconType.CALENDAR,
  },
  [IconType.CREATE]: {
    type: IconType.CREATE,
  },
  [IconType.DOT]: {
    type: IconType.DOT,
  },
  [IconType.BEACH_ACCESS]: {
    type: IconType.BEACH_ACCESS,
  },
  [IconType.FILE_COPY]: {
    type: IconType.FILE_COPY,
  },
  [IconType.UMBRELLA]: {
    type: IconType.UMBRELLA,
  },
  [IconType.INVOICE]: {
    type: IconType.INVOICE,
  },
}

const partnersIcons: PartnersIcons = {
  [PartnerName.instabank]: {
    components: defaultIconComponents,
    props: defaultIconProps,
  },
  [PartnerName.nord]: {
    components: defaultIconComponents,
    props: defaultIconProps,
  },
  [PartnerName.coverme]: {
    components: defaultIconComponents,
    props: defaultIconProps,
  },
  [PartnerName.circlek]: {
    components: circleKIconComponents,
    props: circleKIconProps,
  },
}

export { partnersIcons }
